import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import UDTabs from 'ud-ui/components/tabs';
import { getChampionshipEditTabs } from '../edit-form/constants';

const CreateFormTabs = () => {
  const { t } = useTranslation();

  // При создании соревнования доступна только первая вкладка: остальным нужен
  // уже сохранённый черновик.
  const tabs = useMemo(
    () => getChampionshipEditTabs(t).map((tab) => (tab.hash === ChampionshipEditTab.COMMON ? tab : { ...tab, disabled: true })),
    [t],
  );

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} activeRoutePattern={Pages.CHAMPIONSHIPS.EDIT} />;
};

export default CreateFormTabs;
